export default class CarrierSavedSearchSerializer {
  static serialize(data) {
    const payload = {
      ...data
    };

    return payload;
  }

  static deSerialize(data) {
    return {
      ...data
    };
  }
}